/**
 * @module Utilities/Helpers
 * @desc Helpers helper funtions
 */

import type { Utilities } from 'core/domains';

/**
 * Produces an enumerable object of string literals composed of
 * mirrored keys/values.
 */
export function keyMirror<T extends Utilities.PlainObject>(obj: T): { [K in keyof T]: K } {
  const isNotObject = !(obj instanceof Object && !Array.isArray(obj));

  if (isNotObject) {
    throw new TypeError('keyMirror(...): Argument must be an object.');
  }

  const output: any = {};

  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    /* istanbul ignore else */
    if (!Object.prototype.hasOwnProperty.call(output, key)) {
      output[key] = key;
    }
  }

  return output;
}
